import { render, staticRenderFns } from "./OrganizationMembershipCard.vue?vue&type=template&id=58ceef16"
import script from "./OrganizationMembershipCard.vue?vue&type=script&lang=js"
export * from "./OrganizationMembershipCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports